import SwapIcon from '@material-ui/icons/SwapHoriz';
import styled from 'styled-components';

import { colors } from '../../contrib/ui';

interface IProps {
  playerIsSelected?: boolean;
  swappingInProcess?: boolean;
}

export const SwapIconStyled = styled(SwapIcon)<IProps>`
  color: ${({ playerIsSelected, swappingInProcess }) =>
    playerIsSelected ? colors.teal : swappingInProcess ? colors.orange : colors.greydd} !important;
`;
